module.exports = __webpack_public_path__ + "img/plus.c26a1069.svg";